import React, {Component} from 'react';
import {Container} from './styles';
import {Redirect} from 'react-router-dom';

export default class Options  extends Component {

    constructor(props){
        super(props);
        this.state = {
            redirect: 0
        }
    }

    async push() {
        await this.setState({
            redirect: 1
        });
        this.props.closeModal();
    }

    async logout() {
        try {
            await localStorage.removeItem('@username');
            await localStorage.removeItem('@jwt');
            await localStorage.removeItem('@user');
            await localStorage.removeItem('@rest');
            await localStorage.removeItem('@uf');
            await localStorage.removeItem('@internal');
            await localStorage.removeItem('@suser');
            this.setState({
                redirect: 2
            });
        } catch (e) {
            console.log(e.data);
        }
    }

    render() {
        if (this.state.redirect === 1) {
            return <Redirect push to="/novaSenha" />
        }
        if(this.state.redirect === 2) {
            return <Redirect to='/login' />
        }
        return(
            <>
                <Container>
                    <h1>Minha Conta</h1>

                    <div className="buttons">
                        <button 
                            onClick={() => this.push()}
                            className="senha">Trocar senha</button>
                        <button 
                            onClick={async() => await this.logout()}
                            className="sair">Sair da conta</button>
                    </div>

                </Container>
            </>
        )
    }
}